import { useParams } from "react-router-dom";
import Login from "../Login";

/**
 *
 * @returns receives the request to process the QR code.  Accepts the encrypted code, then forwards to login page for further processing
 */
const ProcessPassQrReturn = () => {
  const { code } = useParams();
  return <Login qrType="pass.qr.return" qrCode={code} />;
};

export default ProcessPassQrReturn;
